module.exports = __webpack_public_path__ + "img/net04.61a84b82.jpg";